import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function CalculadoraPage() {
  const [contacts, setContacts] = useState(10);
  const [closeRate, setCloseRate] = useState(30);
  const [price, setPrice] = useState(350);
  const [recurring, setRecurring] = useState(false);
  const [bump, setBump] = useState(false);
  const closed = Math.round(contacts * (closeRate / 100));
  const sitesIncome = closed * price;
  const bumpIncome = bump ? closed * 17 : 0;
  const weeklyIncome = sitesIncome + bumpIncome;
  const monthlyIncome = weeklyIncome * 4;
  const recurringMonth = recurring ? closed * 4 * 99 : 0;
  const yearlyIncome = monthlyIncome * 12 + recurringMonth * 12;
  const fmt = (n: number) => {
    return '$' + Math.round(n).toLocaleString('en-US');
  };
  return <div className="min-h-screen bg-navy font-body text-white" data-id="element-909">
      {/* Header */}
      <header className="border-b border-gold/20 bg-navy-dark" data-id="element-910">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-911">
          <a href="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-912">
            <ArrowLeftIcon className="h-5 w-5" data-id="element-913" />
            <span className="font-body text-sm" data-id="element-914">Volver</span>
          </a>
          <h1 className="font-heading font-black text-xl md:text-2xl" data-id="element-915">
            <span className="text-gold" data-id="element-916">AI</span> Web Closer
          </h1>
          <div className="w-20" data-id="element-917" />
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-918">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-919">
          <h2 className="font-heading font-black text-3xl md:text-4xl mb-2" data-id="element-920">
            ¿Cuánto Puedes Ganar <span className="text-gold" data-id="element-921">Esta Semana?</span>
          </h2>
          <p className="font-body text-sm text-gray-400" data-id="element-922">
            Mueve los controles y calcula tu ingreso real con el sistema AI Web
            Closer
          </p>
        </motion.div>

        {/* Calculator Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-923">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-924">
            Calculadora de Ingresos
          </div>

          {/* Slider 1: Contacts */}
          <div className="mb-6" data-id="element-925">
            <div className="flex justify-between items-center mb-2" data-id="element-926">
              <span className="font-body text-sm text-gray-300" data-id="element-927">
                Negocios que contactas por semana
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-928">
                {contacts}
              </div>
            </div>
            <input type="range" min="1" max="50" value={contacts} onChange={e => setContacts(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-929" />
          </div>

          {/* Slider 2: Close Rate */}
          <div className="mb-6" data-id="element-930">
            <div className="flex justify-between items-center mb-2" data-id="element-931">
              <span className="font-body text-sm text-gray-300" data-id="element-932">
                Tasa de cierre (% que dice SÍ)
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-933">
                {closeRate}
                <span className="text-xs" data-id="element-934">%</span>
              </div>
            </div>
            <input type="range" min="5" max="60" value={closeRate} onChange={e => setCloseRate(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-935" />
          </div>

          {/* Slider 3: Price */}
          <div className="mb-8" data-id="element-936">
            <div className="flex justify-between items-center mb-2" data-id="element-937">
              <span className="font-body text-sm text-gray-300" data-id="element-938">
                Precio por sitio web
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[70px] text-center" data-id="element-939">
                ${price}
              </div>
            </div>
            <input type="range" min="150" max="1500" step="50" value={price} onChange={e => setPrice(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-940" />
          </div>

          {/* Divider */}
          <div className="relative mb-6" data-id="element-941">
            <div className="absolute inset-0 flex items-center" data-id="element-942">
              <div className="w-full border-t border-gold/20" data-id="element-943"></div>
            </div>
          </div>

          {/* Toggle: Recurring */}
          <div className="flex items-center gap-3 mb-4 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-944">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-945">
              Añadir paquete de mantenimiento mensual ($99/cliente)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-946">
              <input type="checkbox" checked={recurring} onChange={e => setRecurring(e.target.checked)} className="sr-only peer" data-id="element-947" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-948"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-949">
              +$99/mes
            </div>
          </div>

          {/* Toggle: Bump */}
          <div className="flex items-center gap-3 mb-8 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-950">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-951">
              Incluir upsell Kit del Primer Cliente ($17)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-952">
              <input type="checkbox" checked={bump} onChange={e => setBump(e.target.checked)} className="sr-only peer" data-id="element-953" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-954"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-955">
              +$17
            </div>
          </div>

          {/* Breakdown */}
          <div className="pt-2" data-id="element-956">
            <div className="font-heading text-xs font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-957">
              Desglose Semanal
            </div>
            <div className="space-y-2" data-id="element-958">
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-959">
                <span className="font-body text-sm text-gray-400" data-id="element-960">
                  Negocios contactados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-961">
                  {contacts}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-962">
                <span className="font-body text-sm text-gray-400" data-id="element-963">
                  Clientes cerrados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-964">
                  {closed}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-965">
                <span className="font-body text-sm text-gray-400" data-id="element-966">
                  Ingreso por sitios web
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-967">
                  {fmt(sitesIncome)}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-968">
                <span className="font-body text-sm text-gray-400" data-id="element-969">
                  Ingreso recurrente (mes 1)
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-970">
                  {recurring ? `${fmt(closed * 99)}/sem` : '$0'}
                </span>
              </div>
              <div className="flex justify-between items-center py-3 border-t border-gold/20 mt-2" data-id="element-971">
                <span className="font-heading font-bold text-white" data-id="element-972">
                  Total semana 1
                </span>
                <span className="font-heading font-black text-xl text-gold" data-id="element-973">
                  {fmt(weeklyIncome)}
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Pricing Reference */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-974">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-975">
            💰 Precios de Referencia por Nicho
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-976">
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-977">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-978">
                🍕 Restaurantes
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-979">
                $300–$500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-980">
                Alta urgencia
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-981">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-982">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-983">
                🦷 Dentistas
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-984">
                $500–$900
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-985">
                Mayor ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-986">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-987">
                🔧 Talleres
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-988">
                $250–$450
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-989">
                Fácil de cerrar
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-990">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-991">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-992">
                ⚖️ Abogados
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-993">
                $700–$1,500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-994">
                Máximo ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-995">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-996">
                ✂️ Peluquerías
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-997">
                $200–$350
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-998">
                Volumen alto
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-999">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-1000">
                🏋️ Gimnasios
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-1001">
                $350–$600
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-1002">
                Buen margen
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}